export default __webpack_public_path__ + "static/media/elo_cartao_2.31648d83.png";